__turbopack_context__.v({
  "body": "ApiKeys-module-scss-module__fs88MG__body",
  "createdKey": "ApiKeys-module-scss-module__fs88MG__createdKey",
  "createdKey__acknowledge": "ApiKeys-module-scss-module__fs88MG__createdKey__acknowledge",
  "createdKey__meta": "ApiKeys-module-scss-module__fs88MG__createdKey__meta",
  "createdKey__text": "ApiKeys-module-scss-module__fs88MG__createdKey__text",
  "createdKey__value": "ApiKeys-module-scss-module__fs88MG__createdKey__value",
  "empty": "ApiKeys-module-scss-module__fs88MG__empty",
  "empty__text": "ApiKeys-module-scss-module__fs88MG__empty__text",
  "empty__title": "ApiKeys-module-scss-module__fs88MG__empty__title",
  "footnote": "ApiKeys-module-scss-module__fs88MG__footnote",
  "header": "ApiKeys-module-scss-module__fs88MG__header",
  "header__actions": "ApiKeys-module-scss-module__fs88MG__header__actions",
  "header__subtitle": "ApiKeys-module-scss-module__fs88MG__header__subtitle",
  "header__title": "ApiKeys-module-scss-module__fs88MG__header__title",
  "keyName": "ApiKeys-module-scss-module__fs88MG__keyName",
  "keyPrefix": "ApiKeys-module-scss-module__fs88MG__keyPrefix",
  "muted": "ApiKeys-module-scss-module__fs88MG__muted",
  "page": "ApiKeys-module-scss-module__fs88MG__page",
  "panel": "ApiKeys-module-scss-module__fs88MG__panel",
  "panel--padded": "ApiKeys-module-scss-module__fs88MG__panel--padded",
  "tableWrapper": "ApiKeys-module-scss-module__fs88MG__tableWrapper",
  "upgrade": "ApiKeys-module-scss-module__fs88MG__upgrade",
  "upgrade__actions": "ApiKeys-module-scss-module__fs88MG__upgrade__actions",
  "upgrade__list": "ApiKeys-module-scss-module__fs88MG__upgrade__list",
  "upgrade__text": "ApiKeys-module-scss-module__fs88MG__upgrade__text",
  "upgrade__title": "ApiKeys-module-scss-module__fs88MG__upgrade__title",
});
